import { ContactFormContent, LINKS_DESIGN_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { IPrimitiveProps } from "../../section/Primitive"
import { useEffect, useState } from "react"
import { __, getID } from "src/libs/utilities"
import CFTitle from "./CFTitle"
import CFDescription from "./CFDescription" 
import ButtonPrimitive from "../ButtonPrimitive"
import { CFForm } from "./CFForm"

const SEND_CF_MESSAGE = "Your message sended successfully. Thank you for action."
export const ContactFormLayout = (props: IPrimitiveProps): JSX.Element => {
    const primitive: ContactFormContent = ( props.primitive || {} ) as ContactFormContent
    const [height, setHeight]           = useState<number>(0)
    const [iSend, setIsSend]            = useState<boolean>(false)
    const [value, setValue]             = useState<any>({})
    
    useEffect(() => {
        const h: number = document.querySelector(`.cf-${primitive.id}`)?.clientHeight || 0 
        setHeight( h )
    }, [])

    const onSend = () => {
        setIsSend(true)
    }
    const onChange = ( _value: any, field: string ) => {
        console.log(_value, field )
        setValue({
            ...value,
            [field]: _value
        })
    }
    return iSend
        ?
        <div 
            className={`pe-primitive-container landing-cf-primitive ${primitive.className || ""}` } 
            style={{
                minHeight: height
            }}
            data-primitive-type={primitive["data-primitive-type"]}
        > 
            {__( SEND_CF_MESSAGE )}
        </div>
        :
        <div 
            className={`pe-primitive-container landing-cf-primitive ${primitive.className || ""} cf-${primitive.id}  overflow-y-auto p-3`} 
            data-primitive-type={primitive["data-primitive-type"]} 
        > 
            <div className="mb-3 flex-centered flex-column"> 
                <CFTitle {...props} />
                <CFDescription {...props} />
            </div> 
            <CFForm {...props} onChange={onChange} value={value} />
            <div className="container">
                <div className=" row w-100 mt-2">
                    <ButtonPrimitive 
                        primitive={{
                            id: getID( "send-button" ),
                            design_type: LINKS_DESIGN_TYPE.ROUND_OUTLINE_BW,
                            position: {},
                            label: __("Send"), 
                            labelStyle: { fontWeight: "bold", textTransform: "uppercase" },
                            ...primitive.sendButton, 
                        }} 
                        onClick={ onSend }  
                    />
                </div>
            </div>
        </div>
}